import { render } from "./DeactivateRestaurant.vue?vue&type=template&id=4da94318&scoped=true"
import script from "./DeactivateRestaurant.vue?vue&type=script&lang=js"
export * from "./DeactivateRestaurant.vue?vue&type=script&lang=js"

import "./DeactivateRestaurant.vue?vue&type=style&index=0&id=4da94318&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da94318"]])

export default __exports__